import React from "react";
import Article from "../common/Article";

const RequestComplete = (props) => {

  return (
    <>
      <div className="login">
      <Article className="content" login={props.login}>


        <form className="login__form">

          <div className="login__form__inner">

            <div className="notice">
              <h3>COMPLETE</h3>
              <p>Your request has been sent.</p>
              {props.children}
            </div>

          </div>

        </form>

      </Article>
      </div>
    </>
  );
}

export default RequestComplete;
